export default __webpack_public_path__ + "static/media/general.7b0b9200.svg";